<div class="relative z-10 inline-block text-left">
  <div>
    <button type="button" (click)="toggleDropdown()" [class.active]="active" id="id" aria-expanded="true" aria-haspopup="true">
      <ng-content select="button"></ng-content>
    </button>
  </div>
  <div *ngIf="isOpen" class="menu" role="menu" aria-orientation="vertical" aria-labelledby="id" tabindex="-1" [class.right-0]="position === 'right'" [attr.data-placement]="placement">
    <div class="py-1" role="none" (click)="toggleDropdown()" (keyup)="toggleDropdown($event)">
      <ng-content select="menu"></ng-content>
    </div>
  </div>
</div>
